<nav aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    <ng-container
      *ngFor="
        let item of items;
        let last = last;
        let i = index;
        trackBy: trackByFn
      "
    >
      <hyperkit-breadcrumb
        [text]="item.text"
        [link]="item.link"
        [selected]="item.selected || false"
        (clicked)="breadcrumbClick.emit(i)"
      ></hyperkit-breadcrumb>

      <!-- Chevron separator between items -->
      <li
        *ngIf="!last"
        class="breadcrumb-separator-container"
        aria-hidden="true"
      >
        <hyperkit-icon
          color="primary"
          size="base"
          icon="chevron-right"
          aria-hidden="true"
        ></hyperkit-icon>
      </li>
    </ng-container>
  </ol>
</nav>
